// extracted by mini-css-extract-plugin
export var stepActive = "_1y-3";
export var stepCompleted = "_1y-4";
export var stepConnectorLine = "_1y-b";
export var stepIndicatorCircle = "_1y-6";
export var stepIndicatorCircleCompleted = "_1y-7";
export var stepIndicatorCircleDefault = "_1y-8";
export var stepIndicatorTextCompleted = "_1y-9";
export var stepIndicatorTextDefault = "_1y-a";
export var stepPending = "_1y-5";
export var wizardContainer = "_1y-1";
export var wizardContent = "_1y-2";
export var wizardModal = "_1y-0";